import React, { useEffect } from 'react';
import { check, error, info, close } from 'static/icons/resizable';
import { Text, Portal } from 'view/atoms';
import { calculateSimilarDiscountAlertTitle } from 'utils';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { alertSelectors } from 'redux/modules/Alert';
import { closeButtonClick, hideAlert } from 'redux/modules/Alert/alert';
import { AlertType } from 'interfaces/alert.model';
import * as S from './Alert.styles';

const PopupNotifyIcon = {
  [AlertType.success]: check,
  [AlertType.error]: close,
  [AlertType.warning]: error,
  [AlertType.info]: info,
};

type Props = {
  centered?: boolean;
};

export const Alert = ({ centered }: Props) => {
  const dispatch = useAppDispatch();

  const title = useAppSelector(alertSelectors.getTitle);
  const bodyText = useAppSelector(alertSelectors.getText);
  const alertType = useAppSelector(alertSelectors.getType);
  const isShown = useAppSelector(alertSelectors.isShown);

  const isSimilarDiscountTitle = calculateSimilarDiscountAlertTitle(title);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (isShown && !isSimilarDiscountTitle) {
      timeoutId = setTimeout(() => dispatch(hideAlert()), 5000);
    }

    return () => clearTimeout(timeoutId);
  }, [isShown, isSimilarDiscountTitle, isSimilarDiscountTitle]);

  const handleToggleWindow = () => {
    dispatch(hideAlert());
    if (isSimilarDiscountTitle) {
      dispatch(closeButtonClick());
    }
  };

  return (
    <Portal>
      <S.PopupNotify type={alertType} centered={centered}>
        <S.ContentModal>
          <S.IconContainer>
            <S.FilteredIcon
              src={PopupNotifyIcon[alertType!]}
              alt='alert'
              type={alertType}
            />
          </S.IconContainer>
          <S.TextBlock>
            <Text kind='h4' color='gray1'>
              {title}
            </Text>
            <Text kind='body' color='gray1'>
              {bodyText}
            </Text>
          </S.TextBlock>
          <S.CloseButton onClick={handleToggleWindow}>
            <img src={close} alt='Close button' />
          </S.CloseButton>
        </S.ContentModal>
      </S.PopupNotify>
    </Portal>
  );
};
